import actions from "./application-actions";
import getters from "./application-getters";
import mutations from "./application-mutations";
import state from "./application-state";
const ApplicationStore = {
  state,
  mutations,
  actions,
  getters
};
export default ApplicationStore;